/**
 * Marketing home page.
 */
import PageShell from "../components/ui/PageShell";
import GlassPanel from "../components/ui/GlassPanel";

export default function Home() {
  return (
    <PageShell>
      <GlassPanel>
        <div className="space-y-6">
          <p className="text-lg leading-relaxed text-white/90">
            Pax Studios is a Christian multimedia company based in Michigan.
          </p>

          <hr className="border-white/10" />

          <div className="space-y-3">
            <h2 className="text-base font-bold text-white">Our Mission:</h2>
            <p className="leading-relaxed text-white/90">
              To glorify God in our work, to bring joy to others through our work, and to build a
              sustainable business that supports our families and communities with our work.
            </p>
          </div>
        </div>
      </GlassPanel>
    </PageShell>
  );
}
